import { render, staticRenderFns } from "./CancelService.vue?vue&type=template&id=1bc5e870&scoped=true&"
import script from "./CancelService.vue?vue&type=script&lang=js&"
export * from "./CancelService.vue?vue&type=script&lang=js&"
import style0 from "./CancelService.vue?vue&type=style&index=0&id=1bc5e870&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc5e870",
  null
  
)

export default component.exports